import PropTypes from 'prop-types'
import React, { Component } from 'react'

class Breadcrumb extends Component {
  static propTypes = {
    pathArray: PropTypes.array,
  }

  static style = {
    justifyContent: 'space-between',
    padding: '0 15px',
    alignItems: 'center',
    width: '100%',
  }

  render() {
    const { pathArray } = this.props
    return (
      <div style={Breadcrumb.style}>
        {pathArray.map((path, index) => (
          <span key={index}>
            {path}
            {index !== pathArray.length - 1 && ' > '}
          </span>
        ))}
      </div>
    )
  }
}

export default Breadcrumb
